import { AbstractModel } from '@uzurv/core';
import { autoserialize, inheritSerialization } from 'cerialize';

@inheritSerialization(AbstractModel)
export class RideReminderResponse extends AbstractModel {
  @autoserialize
  rideReminderId: number;

  @autoserialize
  rideRequestId: number;

  @autoserialize
  confirmed: boolean;

  @autoserialize
  cancelled: boolean;
}
